module.exports = __webpack_public_path__ + "assets/img/42d7-ae.svg";